import styled from 'styled-components';

const Header = styled.div`
  font-size: var(--font-size-m);
  font-weight: 600;
  color: white;
  padding: 1em 0.5em;
  background-color: var(--color-primary);
  text-align: left;    
  display: flex;
  align-items: center;
  justify-content: start;
`;


export default Header;
